import React from "react";
import {Form, Message, Modal, Table} from "semantic-ui-react";
import userStore from "../stores/userStore";
import Button from "semantic-ui-react/dist/commonjs/elements/Button";
import {observable} from "mobx";
import {observer} from "mobx-react";
import {checkEdit, checkRole} from "../helper/rolehelper";
import Icon from "semantic-ui-react/dist/commonjs/elements/Icon";
import DatePicker from "react-datepicker";
import NumberFormat from "react-number-format";

const DEFAULT_ERROR = "Werte dürfen nicht 0, oder leer sein.";
const TYPE_ERROR = "Falsche Angabe : Art der Tanklieferung";
const LOCATION_ERROR = "Falsche Angabe : Ort wurde nicht angegeben oder Wert ist falsch";

@observer
export default class HeatingOilRow extends React.Component {

    @observable
    editheatingoil = {
        heatingoilType: 1,
        date: new Date(),
        amountliter: 0,
        calorificvalue: 0,
        amountkWh: 0,
        costs: 0,
        proof: "",
        locationId: 0,
        id: 0,
        comment: ""
    };
    @observable
    error = false;

    @observable
    isEditModal = false;

    @observable
    addheatingoilModalOpen = false;

    @observable
    deleteModalOpen = false;

    @observable
    errorMessage = DEFAULT_ERROR;

    @observable privilegedUser = false;

    @observable edit = false;

    componentDidMount() {
    }


    constructor(props) {
        super(props);

        let user = userStore.userRolesFromServer;
        if (checkRole(user, "/heatingoil")) {
            this.privilegedUser = true;
        } else {
            this.privilegedUser = user.toString().includes("admin");
        }
        this.edit = checkEdit(user, "/heatingoil");

        this.state = {
            open: false,
            deleteopen: false,
            delete: true,
            edit: true
        }
    }

    getHeatingOilName(type) {
        if (type === 1) {
            return "Tanklieferung";
        } else if (type === 2) {
            return "Tankkartenabrechnungen";
        } else if (type === 3) {
            return "FremdTankungen";
        } else {
            //todo:error
        }
    }

    //functions for edit
    checkInputValues() {
        console.log(this.editheatingoil);
        //Check if vehicle has heatingoil and check if amounts are right
        if (this.editheatingoil.length !== 0) {

            //Check if editHeatingoil has a valid type (1, 2 or 3)
            let type = (this.editheatingoil.heatingoilType);
            if (type !== 1 && type !== 2 && type !== 3) {
                this.error = true;
                console.log(this.error);
                this.errorMessage = TYPE_ERROR;
                return;
            }

            //Check if location-Id has a valid type (not null, empty or undefined (valid = 1 - 7))
            let locationId = this.editheatingoil.locationId;
            console.log(locationId);
            if (locationId === null || locationId === '' || locationId === undefined) {
                this.error = true;
                this.errorMessage = LOCATION_ERROR;
                return;
            }

            let amountliter = this.editheatingoil.amountliter;
            let costs = this.editheatingoil.costs;
            let proof = this.editheatingoil.proof;
            if (amountliter === "" || costs === "" || amountliter === 0 || costs === "" || costs === 0 || proof === "") {
                this.error = true;
                this.errorMessage = DEFAULT_ERROR;
                console.log("value error");
                console.log(this.error);
                return;
            }
            this.setEdit();
        } else {
            this.error = true;
            console.log(this.error);
        }
    }

    setEdit() {
        console.log(this.editheatingoil.date);

        this.props.editHeatingOil(this.editheatingoil, (1));

        this.closeInput()
    }


    openEditHeatingOilModal() {
        this.editheatingoil.heatingoilType = this.props.heatingoil.heatingoilType;
        this.editheatingoil.date = new Date(this.props.heatingoil.date * 1000);
        this.editheatingoil.amountliter = this.props.heatingoil.amountliter;
        this.editheatingoil.calorificvalue = this.props.heatingoil.calorificvalue;
        this.editheatingoil.amountkWh = this.props.heatingoil.amountkWh;
        this.editheatingoil.costs = this.props.heatingoil.costs;
        this.editheatingoil.proof = this.props.heatingoil.proof;
        this.editheatingoil.comment = this.props.heatingoil.comment;
        this.editheatingoil.locationId = this.props.locationId;
        this.editheatingoil.id = this.props.heatingoil.id;
    }

    handleChange(date) {
        if (date === null) {
            this.setState({
                ...this.state,
                error: true
            })
        } else {
            this.editheatingoil.date = date;
        }
    }


    getTypeId(name) {
        if (name === "Tanklieferung") {
            return 1;
        } else if (name === "Tankkarte") {
            return 2;
        } else {
            return 3;
        }
    }

    closeInput() {

        this.isEditModal = false;
        this.addheatingoilModalOpen = false;
        this.state.open = false;
        this.deleteModalOpen = false;
        this.editheatingoil = {
            heatingoilType: this.props.heatingoil.heatingoilType,
            date: new Date(this.props.heatingoil.date * 1000),
            amountliter: this.props.heatingoil.amountliter,
            calorificvalue: this.props.heatingoil.calorificvalue,
            amountkWh: this.props.heatingoil.amountkWh,
            costs: this.props.heatingoil.costs,
            proof: this.props.heatingoil.proof,
            locationId: this.props.locationId,
            comment: this.props.heatingoil.comment,
            id: this.props.heatingoil.id
        };

        this.error = false;
    }


    handleInputChange(type, event, data) {
        this.editheatingoil.calorificvalue = 9.93;

        this.editheatingoil.amountkWh = this.editheatingoil.amountliter * this.editheatingoil.calorificvalue;
        if (type === 'heatingoilType') {
            this.editheatingoil.heatingoilType = data.value;
        } else if (type === 'date') {
            this.editheatingoil.date = data.value;
        } else if (type === 'amountliter') {
            if (data.value === "") {
                this.editheatingoil.amountliter = 0;
            } else {
                this.editheatingoil.amountliter = data.value;
            }
        } else if (type === 'costs') {
            this.editheatingoil.costs = data.value;
        } else if (type === 'proof') {
            this.editheatingoil.proof = data.value;
        } else if (type === 'comment') {
            this.editheatingoil.comment = data.value;
        }
        this.editheatingoil.locationId = this.props.locationId;
    }

    //functions for edit


    //functions for delete


    openDeleteHeatingOilModal(heatingoilsId) {
        this.deleteModalOpen = true;
        console.log(this.props.heatingoil)
        this.props.deleteHeatingOil(heatingoilsId);
        this.closeDeleteInput();
    }


    closeDeleteInput() {
        this.addheatingoilModalOpen = false;
        this.isEditModal = false;
        this.state.deleteopen = false;
        this.deleteModalOpen = false;
        this.editheatingoil = {
            heatingoilType: 1,
            date: new Date(),
            amountliter: "",
            calorificvalue: "",
            amountkWh: "",
            costs: "",
            proof: "",
            comment: ""
        };
        console.log(this.state.deleteopen);
        this.error = false;
    }

    //functions for delete


    getTypeId(name) {
        if (name === "Tanklieferung") {
            return 1;
        } else if (name === "Tankkarte") {
            return 2;
        } else {
            return 3;
        }
    }

    render() {
        const IdOptions = [
            {key: 4, text: 'Tanklieferung', value: 1},
            {key: 5, text: 'Tankkarte', value: 2},
            {key: 6, text: 'Fremdtankung', value: 3}
        ];
        const calorificvalue = 9.93;

        return (

            <Table.Row className="color-sub-row">
                <Table.Cell/>
                {this.edit ?
                    <Table.Cell>
                        <Modal open={this.state.deleteopen} className={"modal-top"}
                               onClose={this.closeDeleteInput.bind(this)} centered={false}
                               trigger={this.delete ?
                                   <Icon name='delete' color="red"
                                         onClick={() => this.setState({deleteopen: true, delete: true})}/>
                                   :
                                   <Icon name='delete' color="red"
                                         onClick={() => this.setState({deleteopen: true, delete: true})}/>
                               }>
                            <Modal.Header>Löschen</Modal.Header>
                            <Modal.Content>
                                Sicher löschen?
                            </Modal.Content>
                            <Modal.Actions>
                                <Button negative icon='delete' onClick={this.closeDeleteInput.bind(this)}/>
                                <Button
                                    positive
                                    icon='checkmark'
                                    onClick={this.openDeleteHeatingOilModal.bind(this, this.props.heatingoil.id)}

                                />
                            </Modal.Actions>
                        </Modal>
                    </Table.Cell>
                    :
                    null
                }
                {this.edit ?
                    <Table.Cell>
                        <Modal centered={false} className={"modal-top"} open={this.state.open} size="small"
                               trigger={
                                   <Icon name='edit' color="green"
                                         onClick={() => {
                                             this.openEditHeatingOilModal();
                                             this.setState({open: true, edit: true});
                                         }}/>
                               }>
                            <Modal.Header>{this.isEditModal ? "Bearbeiten" : "Hinzufügen"}</Modal.Header>
                            <Modal.Content>
                                <Form error={this.error}>
                                    <Form.Group widths='equal'>


                                        <Form.Field>
                                            <label>Datum</label>

                                            <DatePicker
                                                selected={this.editheatingoil.date}
                                                onChange={this.handleChange.bind(this)}
                                                dateFormat="dd.MM.yyyy"
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Field>
                                            <label>Menge [l]</label>
                                            <NumberFormat value={parseFloat(this.editheatingoil.amountliter)}
                                                          thousandSeparator="."
                                                          decimalSeparator=","
                                                          decimalScale={2}
                                                          onValueChange={(values, e) => {
                                                              this.handleInputChange('amountliter', null, {value: values.floatValue})
                                                          }}
                                                          allowNegative={true}
                                                          suffix=" l"/>
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Heizwert</label>
                                            {calorificvalue}
                                        </Form.Field>
                                        <Form.Field>
                                            <label>kWh</label>
                                            {Math.round(this.editheatingoil.amountliter * calorificvalue * 100) / 100}
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Kosten [€]</label>
                                            <NumberFormat value={parseFloat(this.editheatingoil.costs)}
                                                          thousandSeparator="."
                                                          decimalSeparator=","
                                                          decimalScale={2}
                                                          onValueChange={(values, e) => {
                                                              console.log()
                                                              this.handleInputChange('costs', null, {value: values.floatValue})
                                                          }}
                                                          allowNegative={true}
                                                          suffix=" €"/>
                                        </Form.Field>
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Field>
                                            <label>Nachweis</label>
                                            <Form.Input value={this.editheatingoil.proof}
                                                        type='proof'
                                                        onChange={this.handleInputChange.bind(this, 'proof')}/>
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Bemerkung</label>
                                            <Form.Input value={this.editheatingoil.comment}
                                                        type='comment'
                                                        onChange={this.handleInputChange.bind(this, 'comment')}/>
                                        </Form.Field>

                                    </Form.Group>
                                    <Message
                                        error
                                        header='Fehler'
                                        content={this.errorMessage}
                                    />
                                </Form>
                            </Modal.Content>
                            <Modal.Actions>
                                <Button negative icon='delete' onClick={this.closeInput.bind(this)}/>
                                <Button
                                    positive
                                    icon='checkmark'
                                    onClick={() => this.checkInputValues()}
                                />
                            </Modal.Actions>
                        </Modal>
                    </Table.Cell>
                    :
                    null
                }
                <Table.Cell>
                    {new Date(this.props.heatingoil.date * 1000).toLocaleDateString()}
                </Table.Cell>
                <Table.Cell>
                    {new Intl.NumberFormat('de-DE', {style: 'decimal'}).format(this.props.heatingoil.amountliter)}
                </Table.Cell>
                <Table.Cell>
                    {new Intl.NumberFormat('de-DE', {style: 'decimal'}).format(this.props.heatingoil.calorificvalue)}
                </Table.Cell>
                <Table.Cell>
                    {new Intl.NumberFormat('de-DE', {style: 'decimal'}).format(this.props.heatingoil.amountkWh)}
                </Table.Cell>
                <Table.Cell>
                    {new Intl.NumberFormat('de-DE', {
                        style: 'currency',
                        currency: 'EUR'
                    }).format(this.props.heatingoil.costs.toFixed(2))}
                </Table.Cell>
                <Table.Cell>
                    {this.props.heatingoil.comment}
                </Table.Cell>
                <Table.Cell>
                    {this.props.heatingoil.proof}
                </Table.Cell>
            </Table.Row>
        );
    }
}